export enum ReturnTypeEnum {
    ZERO = 'enums.returnType.normal',
    ONE = 'enums.returnType.partialReturn',
    TWO = 'enums.returnType.partialCancellation'
}
